import { jsx as _jsx } from "react/jsx-runtime";
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { compose } from 'redux';
import * as apiActions from 'api-actions';
import TermsAgreement from './TermsAgreement';
const TermsAgreementShell = ({ getLenderTerms, lenderName, locationId, }) => {
    const [terms, setTerms] = useState(null);
    const initData = async () => {
        const resp = await getLenderTerms(locationId, lenderName);
        if (resp && resp.terms) {
            setTerms(resp.terms);
        }
    };
    useEffect(() => {
        initData();
    }, []);
    return _jsx(TermsAgreement, { terms: terms });
};
const mapDispatchToProps = {
    getLenderTerms: apiActions.getLenderTerms,
};
export default compose(connect(null, mapDispatchToProps))(TermsAgreementShell);
